export enum AnalysisType {
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  SINGLE_RETAILER = 'SINGLE_RETAILER',
  MULTI_RETAILER = 'MULTI_RETAILER'
}
